var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#2D72FE",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2145 3.80802C17.3176 2.73066 19.0872 2.73066 20.1903 3.80802C21.2933 4.88539 21.2933 6.65043 20.2132 7.77364L13.3878 14.6275C13.2959 14.6963 13.181 14.765 13.0661 14.788L9.0674 15.8195H8.90654C8.72269 15.8195 8.53884 15.7507 8.40095 15.6132C8.24008 15.4298 8.17114 15.1776 8.2171 14.9484L9.22827 10.9599C9.25125 10.8453 9.3202 10.7307 9.41212 10.639L16.2145 3.80802ZM9.84876 14.169L12.5605 13.4814L18.053 7.97994L16.0077 5.96275L10.5152 11.4642L9.84876 14.169ZM19.0182 7.01719L19.225 6.81089C19.5008 6.53581 19.6387 6.16905 19.6387 5.80229C19.6387 5.41261 19.5008 5.04584 19.225 4.79369L19.1791 4.74785C18.6275 4.22063 17.7313 4.24355 17.2027 4.79369L16.9959 5L19.0182 7.01719ZM10.4229 5.68769C10.3999 6.05445 10.1012 6.35244 9.73346 6.32952H4.37887V19.6246H17.6849V13.4126C17.6849 13.0229 17.9837 12.7249 18.3744 12.7249H18.4203C18.788 12.7479 19.0868 13.0458 19.0638 13.4126V20.3123C19.0638 20.702 18.765 21 18.3744 21H3.68943C3.29875 21 3 20.702 3 20.3123V5.64184C3 5.25216 3.29875 4.95416 3.68943 4.95416H9.73346C10.1241 4.95416 10.4229 5.25216 10.4229 5.64184V5.68769Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnEdit);
export default __webpack_public_path__ + "static/media/icn_edit.94260e4a73ea09e4f88c8626f8d57867.svg";
export { ForwardRef as ReactComponent };